/**
 *日志行为类型
 *@author xujinjiang
 *@date 2022/2/18 16:29
 */
export const actionType = {
  login: {
    englishTitle: 'login',
    chineseTitle: '登录'
  },
  applyRead: {
    englishTitle: 'applyRead',
    chineseTitle: '查看申请'
  },
  developerAdd: {
    englishTitle: 'developerAdd',
    chineseTitle: '新增开发者'
  },
  developerEdit: {
    englishTitle: 'developerEdit',
    chineseTitle: '编辑开发者'
  },
  addUserCount: {
    englishTitle: 'addUserCount',
    chineseTitle: '新增配额'
  },
  setPassword: {
    englishTitle: 'setPassword',
    chineseTitle: '修改密码'
  },
  setStatus: {
    englishTitle: 'setStatus',
    chineseTitle: '修改状态'
  },
  organizationAdd: {
    englishTitle: 'organizationAdd',
    chineseTitle: '新增机构'
  },
  organizationEdit: {
    englishTitle: 'organizationEdit',
    chineseTitle: '修改机构'
  },
  organizationUserAdd: {
    englishTitle: 'organizationUserAdd',
    chineseTitle: '添加机构用户'
  }
};
